export const REDIRECCIONAMIENTO_GLOBAL = "https://cademonline.cl";

export const API_BASE_URL_ENCUESTAS_DESTACADAS  = process.env.NODE_ENV === 'production' 
                                ? 'https://backend-encuestas-destacadas-ba7zkvym3a-ue.a.run.app'
                                : 'http://localhost:5000';

export const URL_BASE_LIMESURVEY = "https://s5.cademonline.cl/limesurvey/index.php";
//url formulario cloud run 
export const URL_FORMULARIO_REGISTRO = "https://formulario.cademonline.cl/formulario-registro";

export const URL_API_PANEL = "https://be-panel-cadem-ba7zkvym3a-ue.a.run.app/api/utils/v1";
// export const URL_API_PANEL = "http://127.0.0.1:8080/api/utils/v1";